import React from 'react';
import { useGame } from '../../context/GameContext';
import './TurnManagement.css';

const TurnSetup = () => {
  const { 
    gameState, 
    isMyTurn, 
    activePlayerName,
    handleStartTurn
  } = useGame();

  // Only show this component when game state is turn_setup
  if (gameState !== 'turn_setup') {
    return null;
  }

  return (
    <div className="turn-management-section">
      {isMyTurn ? (
        <div className="turn-setup-section">
          <h3>It's Your Turn!</h3>
          <p>You will be assigned a word to describe using only words from the dictionary.</p>
          <button className="start-turn-btn" onClick={handleStartTurn}>
            Start My Turn
          </button>
        </div>
      ) : (
        <div className="waiting-for-turn-section">
          <h3>Waiting for {typeof activePlayerName === 'string' ? activePlayerName : ''}'s Turn</h3>
          <p className="waiting-text">{typeof activePlayerName === 'string' ? activePlayerName : ''} is preparing to describe a word...</p>
        </div>
      )}
    </div>
  );
};

export default TurnSetup; 